export default __webpack_public_path__ + "static/20-d0b4c7d7701ef2f58626a392d37cc5ab.jpg";